export default {
  STEP: 'step'
};
